/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {AddCompany} from '../bioplanModels';
// @ts-ignore
import type {Company} from '../bioplanModels';
// @ts-ignore
import type {EditCompany} from '../bioplanModels';
/**
 * PlanningCompanyApi - axios parameter creator
 * @export
 */
export const PlanningCompanyApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Delete company by its identifier
     * @param {string} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    companiesCompanyIdDelete: async (companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'companyId' is not null or undefined
      assertParamExists('companiesCompanyIdDelete', 'companyId', companyId);
      const localVarPath = `/companies/{companyId}`.replace(`{${'companyId'}}`, encodeURIComponent(String(companyId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get company by its identifier
     * @param {string} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    companiesCompanyIdGet: async (companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'companyId' is not null or undefined
      assertParamExists('companiesCompanyIdGet', 'companyId', companyId);
      const localVarPath = `/companies/{companyId}`.replace(`{${'companyId'}}`, encodeURIComponent(String(companyId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update company
     * @param {string} companyId
     * @param {EditCompany} editCompany
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    companiesCompanyIdPut: async (
      companyId: string,
      editCompany: EditCompany,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'companyId' is not null or undefined
      assertParamExists('companiesCompanyIdPut', 'companyId', companyId);
      // verify required parameter 'editCompany' is not null or undefined
      assertParamExists('companiesCompanyIdPut', 'editCompany', editCompany);
      const localVarPath = `/companies/{companyId}`.replace(`{${'companyId'}}`, encodeURIComponent(String(companyId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(editCompany, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all companies for the provided planId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    companiesGet: async (planId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('companiesGet', 'planId', planId);
      const localVarPath = `/companies/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create company
     * @param {AddCompany} addCompany
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    companiesPost: async (addCompany: AddCompany, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'addCompany' is not null or undefined
      assertParamExists('companiesPost', 'addCompany', addCompany);
      const localVarPath = `/companies/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(addCompany, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PlanningCompanyApi - functional programming interface
 * @export
 */
export const PlanningCompanyApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PlanningCompanyApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Delete company by its identifier
     * @param {string} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async companiesCompanyIdDelete(
      companyId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.companiesCompanyIdDelete(companyId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningCompanyApi.companiesCompanyIdDelete']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get company by its identifier
     * @param {string} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async companiesCompanyIdGet(
      companyId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Company>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.companiesCompanyIdGet(companyId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningCompanyApi.companiesCompanyIdGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update company
     * @param {string} companyId
     * @param {EditCompany} editCompany
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async companiesCompanyIdPut(
      companyId: string,
      editCompany: EditCompany,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Company>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.companiesCompanyIdPut(companyId, editCompany, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningCompanyApi.companiesCompanyIdPut']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get all companies for the provided planId
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async companiesGet(
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Company>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.companiesGet(planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningCompanyApi.companiesGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create company
     * @param {AddCompany} addCompany
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async companiesPost(
      addCompany: AddCompany,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Company>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.companiesPost(addCompany, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningCompanyApi.companiesPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PlanningCompanyApi - factory interface
 * @export
 */
export const PlanningCompanyApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PlanningCompanyApiFp(configuration);
  return {
    /**
     *
     * @summary Delete company by its identifier
     * @param {PlanningCompanyApiCompaniesCompanyIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    companiesCompanyIdDelete(
      requestParameters: PlanningCompanyApiCompaniesCompanyIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .companiesCompanyIdDelete(requestParameters.companyId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get company by its identifier
     * @param {PlanningCompanyApiCompaniesCompanyIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    companiesCompanyIdGet(
      requestParameters: PlanningCompanyApiCompaniesCompanyIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Company> {
      return localVarFp
        .companiesCompanyIdGet(requestParameters.companyId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update company
     * @param {PlanningCompanyApiCompaniesCompanyIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    companiesCompanyIdPut(
      requestParameters: PlanningCompanyApiCompaniesCompanyIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Company> {
      return localVarFp
        .companiesCompanyIdPut(requestParameters.companyId, requestParameters.editCompany, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all companies for the provided planId
     * @param {PlanningCompanyApiCompaniesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    companiesGet(
      requestParameters: PlanningCompanyApiCompaniesGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<Company>> {
      return localVarFp.companiesGet(requestParameters.planId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create company
     * @param {PlanningCompanyApiCompaniesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    companiesPost(
      requestParameters: PlanningCompanyApiCompaniesPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Company> {
      return localVarFp
        .companiesPost(requestParameters.addCompany, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for companiesCompanyIdDelete operation in PlanningCompanyApi.
 * @export
 * @interface PlanningCompanyApiCompaniesCompanyIdDeleteRequest
 */
export interface PlanningCompanyApiCompaniesCompanyIdDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningCompanyApiCompaniesCompanyIdDelete
   */
  readonly companyId: string;
}

/**
 * Request parameters for companiesCompanyIdGet operation in PlanningCompanyApi.
 * @export
 * @interface PlanningCompanyApiCompaniesCompanyIdGetRequest
 */
export interface PlanningCompanyApiCompaniesCompanyIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningCompanyApiCompaniesCompanyIdGet
   */
  readonly companyId: string;
}

/**
 * Request parameters for companiesCompanyIdPut operation in PlanningCompanyApi.
 * @export
 * @interface PlanningCompanyApiCompaniesCompanyIdPutRequest
 */
export interface PlanningCompanyApiCompaniesCompanyIdPutRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningCompanyApiCompaniesCompanyIdPut
   */
  readonly companyId: string;

  /**
   *
   * @type {EditCompany}
   * @memberof PlanningCompanyApiCompaniesCompanyIdPut
   */
  readonly editCompany: EditCompany;
}

/**
 * Request parameters for companiesGet operation in PlanningCompanyApi.
 * @export
 * @interface PlanningCompanyApiCompaniesGetRequest
 */
export interface PlanningCompanyApiCompaniesGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningCompanyApiCompaniesGet
   */
  readonly planId: string;
}

/**
 * Request parameters for companiesPost operation in PlanningCompanyApi.
 * @export
 * @interface PlanningCompanyApiCompaniesPostRequest
 */
export interface PlanningCompanyApiCompaniesPostRequest {
  /**
   *
   * @type {AddCompany}
   * @memberof PlanningCompanyApiCompaniesPost
   */
  readonly addCompany: AddCompany;
}

/**
 * PlanningCompanyApi - object-oriented interface
 * @export
 * @class PlanningCompanyApi
 * @extends {BaseAPI}
 */
export class PlanningCompanyApi extends BaseAPI {
  /**
   *
   * @summary Delete company by its identifier
   * @param {PlanningCompanyApiCompaniesCompanyIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningCompanyApi
   */
  public companiesCompanyIdDelete(
    requestParameters: PlanningCompanyApiCompaniesCompanyIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningCompanyApiFp(this.configuration)
      .companiesCompanyIdDelete(requestParameters.companyId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get company by its identifier
   * @param {PlanningCompanyApiCompaniesCompanyIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningCompanyApi
   */
  public companiesCompanyIdGet(
    requestParameters: PlanningCompanyApiCompaniesCompanyIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningCompanyApiFp(this.configuration)
      .companiesCompanyIdGet(requestParameters.companyId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update company
   * @param {PlanningCompanyApiCompaniesCompanyIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningCompanyApi
   */
  public companiesCompanyIdPut(
    requestParameters: PlanningCompanyApiCompaniesCompanyIdPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningCompanyApiFp(this.configuration)
      .companiesCompanyIdPut(requestParameters.companyId, requestParameters.editCompany, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get all companies for the provided planId
   * @param {PlanningCompanyApiCompaniesGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningCompanyApi
   */
  public companiesGet(requestParameters: PlanningCompanyApiCompaniesGetRequest, options?: RawAxiosRequestConfig) {
    return PlanningCompanyApiFp(this.configuration)
      .companiesGet(requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create company
   * @param {PlanningCompanyApiCompaniesPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningCompanyApi
   */
  public companiesPost(requestParameters: PlanningCompanyApiCompaniesPostRequest, options?: RawAxiosRequestConfig) {
    return PlanningCompanyApiFp(this.configuration)
      .companiesPost(requestParameters.addCompany, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
